export default {
    fr: require('./translations/messages.fr.json'),
    nl: require('./translations/messages.nl.json'),
    en: require('./translations/messages.en.json'),
    de: require('./translations/messages.de.json'),
    da: require('./translations/messages.da.json'),
    sv: require('./translations/messages.sv.json'),
    it: require('./translations/messages.it.json'),
    pl: require('./translations/messages.pl.json'),
    es: require('./translations/messages.es.json'),
    pt: require('./translations/messages.pt.json'),
}
